import React from "react";
import { Box, Heading } from "grommet";
import { TeamName } from "../teams/TeamName";
import { RenderWinner } from "./TournamentProfile";
import { TournamentMatchViewModel, TournamentParticipantViewModel, TournamentViewModel } from "./TournamentsStore";
import { flatten, orderBy, uniqBy } from "lodash";
import { MatchParticipantViewModel } from "../matches/MatchesStore";

export const TournamentResult = ({ tournament }: { tournament: TournamentViewModel }) => {
    const winner = tournament.bracket?.finals?.winner;
    const matches = orderBy(flatten(tournament.bracket?.rounds.map((r) => r.matches)), ["tournamentMatchID"], ["desc"]);

    const matchPosition = (tournamentMatch: TournamentMatchViewModel) => {
        let winner = tournamentMatch.match.participants.filter((p) => p.teamID == tournamentMatch.winner)[0];
        let loser = tournamentMatch.match.participants.filter((p) => p.teamID != tournamentMatch.winner)[0];

        if (tournamentMatch.tournamentMatchID == tournament.bracket?.finals?.tournamentMatchID) {
            return [winner, loser];
        } else {
            return loser;
        }
    };
    let ladder = [] as MatchParticipantViewModel[];

    ladder = uniqBy(
        flatten(matches.map(matchPosition)).filter((f) => f),
        "teamID"
    ).slice(1);

    const ordinalSuffix = (position) => {
        const j = position % 10;
        const k = position % 100;

        if (j == 1 && k != 11) {
            return "st";
        }
        if (j == 2 && k != 12) {
            return "nd";
        }
        if (j == 3 && k != 13) {
            return "rd";
        }
        return "th";
    };

    return (
        <>
            {winner && <RenderWinner size={5} tournamentMatch={tournament.bracket?.finals}></RenderWinner>}

            {ladder.map((match, i) => (
                <Box key={i}>
                    <Box direction="row" align="center" justify="start" gap="small" fill="horizontal">
                        <Heading size="small">
                            {i + 2}
                            {ordinalSuffix(i + 2)}
                        </Heading>
                        <img src={match.team.logoUri} width="60px" alt="" />
                        <TeamName team={match.team} size="1rem" color={""}></TeamName>
                    </Box>
                </Box>
            ))}
        </>
    );
};
